import { X } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import type { AiFilterCondition } from '@/types/components/audience-filter-modal'

interface AskAiFilterChipsProps {
  chips: AiFilterCondition[]
  onRemove: (column: string) => void
}

export function AskAiFilterChips({ chips, onRemove }: AskAiFilterChipsProps) {
  if (!chips || chips.length === 0) return null

  return (
    <div className="flex flex-wrap gap-1.5" data-testid="ask-ai-chips">
      {chips.map((chip) => (
        <Badge
          key={chip.column}
          variant="outline"
          className="gap-1 pl-2 pr-1 text-xs font-normal max-w-[200px]"
          title={`${chip.displayQuestion}: ${chip.displayAnswer}`}
        >
          <span className="truncate">{chip.chip}</span>
          <button
            onClick={() => onRemove(chip.column)}
            className="ml-0.5 rounded-full p-0.5 hover:bg-muted-foreground/20"
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      ))}
    </div>
  )
}
